module.exports = __webpack_public_path__ + "img/Shipping.39a0108d.svg";